import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { useT } from '../services/i18n';
import { authAPI } from '../services/api';
import { useReferral, ensureReferralCode } from '../services/referral';

// Small nudge next to the share buttons: logged-in customers earn −X % when a friend places a first order through their link
export const ShareRewardHint = ({ testId = 'share-reward-hint' }) => {
  const { t } = useT();
  const authed = authAPI.isAuthenticated();
  const ref = useReferral();
  useEffect(() => { if (authed) ensureReferralCode(); }, [authed]);
  if (authed && ref && ref.enabled === false) return null;
  const pct = ref?.percent ?? 5;
  return (
    <p className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2.5 py-1.5 inline-flex items-center gap-1.5" data-testid={testId}>
      <Gift size={12} className="shrink-0" />
      {authed
        ? <span>{t('share.rewardHint', { p: pct })} <Link to="/mon-compte/parrainage" className="underline font-medium" data-testid={`${testId}-link`}>{t('share.rewardMore')}</Link></span>
        : <span>{t('share.rewardGuest', { p: pct })} <Link to="/connexion" className="underline font-medium" data-testid={`${testId}-login`}>{t('share.rewardLogin')}</Link></span>}
    </p>
  );
};

export default ShareRewardHint;
